
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.jpeg";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn
} from "react-icons/fa";

function Navbar() {

  const [isOpen, setIsOpen] = useState(false);

  const [desktopExpertiseOpen, setDesktopExpertiseOpen] = useState(false);

  const [mobileExpertiseOpen, setMobileExpertiseOpen] = useState(false);

  useEffect(() => {

    document.body.style.overflow = isOpen ? "hidden" : "auto";

  }, [isOpen]);


  // Close desktop Expertise dropdown when a link is clicked
  const handleDesktopExpertiseClick = () => {
    setDesktopExpertiseOpen(false);
  };


  // Close mobile menu and Expertise dropdown
  const handleMobileExpertiseClick = () => {
    setIsOpen(false);
    setMobileExpertiseOpen(false);
  };


  // Close mobile menu
  const handleMobileBookingClick = () => {
    setIsOpen(false);
    setMobileExpertiseOpen(false);
  };


  return (

    <nav className="navbar">

      <div className="navbar-container">


        {/* LOGO */}

        <img
          src={logo}
          alt="Satima Technova Logo"
          className="navbar-logo"
        />


        {/* DESKTOP LINKS */}

        <ul className="navbar-links-desktop">


          <li>

            <Link to="/">
              Home
            </Link>

          </li>


          <li>

            <Link to="/about">
              About
            </Link>

          </li>


          {/* EXPERTISE DROPDOWN */}

          <li className="nav-dropdown">

            <span
              className="nav-dropdown-title"
              onClick={() =>
                setDesktopExpertiseOpen(!desktopExpertiseOpen)
              }
            >

              Expertise {desktopExpertiseOpen ? "▲" : "▼"}

            </span>


            {desktopExpertiseOpen && (

              <ul className="dropdown-menu">


                <li>

                  <Link
                    to="/web-design-kenya/"
                    onClick={handleDesktopExpertiseClick}
                  >
                    Web Design in Kenya
                  </Link>

                </li>


                <li>

                  <Link
                    to="/digital-marketing-smes/"
                    onClick={handleDesktopExpertiseClick}
                  >
                    Digital Marketing for SMEs
                  </Link>

                </li>


                <li>

                  <Link
                    to="/social-media-management-services/"
                    onClick={handleDesktopExpertiseClick}
                  >
                    Social Media Management
                  </Link>

                </li>


                <li>

                  <Link
                    to="/seo-services-kenya/"
                    onClick={handleDesktopExpertiseClick}
                  >
                    SEO Services in Kenya
                  </Link>

                </li>


                <li>

                  <Link
                    to="/digital-strategy-consultation/"
                    onClick={handleDesktopExpertiseClick}
                  >
                    Digital Strategy &amp; Consultation
                  </Link>

                </li>


                <li>

                  <Link
                    to="/custom-software-solutions/"
                    onClick={handleDesktopExpertiseClick}
                  >
                    Custom Software Solutions
                  </Link>

                </li>


              </ul>

            )}

          </li>


          <li>

            <Link to="/the-satima-way">
              The Satima Way
            </Link>

          </li>


          {/* CATALOGUE LINK */}

          <li>

            <a
              href="https://catalogue.satimatechnova.co.ke"
              target="_blank"
              rel="noopener noreferrer"
            >
              Catalogue
            </a>

          </li>


          <li>

            <Link to="/contact">
              Contact
            </Link>

          </li>


          {/* BOOK OUR SERVICES */}

          <li>

            <a
              href="https://booking.satimatechnova.co.ke"
              className="navbar-booking-link"
            >
              Book Our Services
            </a>

          </li>


        </ul>


        {/* SOCIAL MEDIA */}

        <div className="navbar-social">


          <a
            href="https://www.facebook.com/share/1ZEARUmfKZ/"
            target="_blank"
            rel="noopener noreferrer"
          >

            <FaFacebookF />

          </a>


          <a
            href="https://www.instagram.com/satimatechnovasolutions/"
            target="_blank"
            rel="noopener noreferrer"
          >

            <FaInstagram />

          </a>


          <a
            href="https://www.linkedin.com/company/107933110/"
            target="_blank"
            rel="noopener noreferrer"
          >

            <FaLinkedinIn />

          </a>


        </div>


        {/* HAMBURGER */}

        <div
          className={`hamburger ${isOpen ? "open" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >

          <span></span>

          <span></span>

          <span></span>

        </div>


      </div>


      {/* MOBILE MENU */}

      <div className={`mobile-dropdown ${isOpen ? "show" : ""}`}>

        <ul className="mobile-links">


          <li onClick={() => setIsOpen(false)}>

            <Link to="/">
              Home
            </Link>

          </li>


          <li onClick={() => setIsOpen(false)}>

            <Link to="/about">
              About
            </Link>

          </li>


          {/* MOBILE EXPERTISE */}

          <li>


            <span
              className="mobile-dropdown-title"
              onClick={() =>
                setMobileExpertiseOpen(!mobileExpertiseOpen)
              }
            >

              Expertise {mobileExpertiseOpen ? "▲" : "▼"}

            </span>


            {mobileExpertiseOpen && (

              <ul className="mobile-sub-links">


                <li onClick={handleMobileExpertiseClick}>

                  <Link to="/web-design-kenya/">
                    Web Design in Kenya
                  </Link>

                </li>


                <li onClick={handleMobileExpertiseClick}>

                  <Link to="/digital-marketing-smes/">
                    Digital Marketing for SMEs
                  </Link>

                </li>


                <li onClick={handleMobileExpertiseClick}>

                  <Link to="/social-media-management-services/">
                    Social Media Management
                  </Link>

                </li>


                <li onClick={handleMobileExpertiseClick}>

                  <Link to="/seo-services-kenya/">
                    SEO Services in Kenya
                  </Link>

                </li>


                <li onClick={handleMobileExpertiseClick}>

                  <Link to="/digital-strategy-consultation/">
                    Digital Strategy &amp; Consultation
                  </Link>

                </li>


                <li onClick={handleMobileExpertiseClick}>

                  <Link to="/custom-software-solutions/">
                    Custom Software Solutions
                  </Link>

                </li>


              </ul>

            )}

          </li>


          <li onClick={() => setIsOpen(false)}>

            <Link to="/the-satima-way">
              The Satima Way
            </Link>

          </li>


          {/* MOBILE CATALOGUE LINK */}

          <li onClick={() => setIsOpen(false)}>

            <a
              href="https://catalogue.satimatechnova.co.ke"
              target="_blank"
              rel="noopener noreferrer"
            >
              Catalogue
            </a>

          </li>


          <li onClick={() => setIsOpen(false)}>

            <Link to="/contact">
              Contact
            </Link>

          </li>


          {/* MOBILE BOOKING LINK */}

          <li onClick={handleMobileBookingClick}>

            <a
              href="https://booking.satimatechnova.co.ke"
              className="mobile-booking-link"
            >
              Book Our Services
            </a>

          </li>


        </ul>

      </div>


    </nav>

  );

}


export default Navbar;